export default {
  title: "Passes",
  availableAmount: "Available {amount}",
  makePass: "Issue the pass",
  untilDeadline: "Until {date}",
  downloadNotification: "Now you can download your passes",
  downloadTooltip: "Download/print the pass",
  processedStatus: "Processed",
  errorBarcodeStatusShort: "Error",
  errorVisaPass: "Cancelled",
  errorBarcodeStatus: "Pass generation error",

  participantPasses: "Exhibitor passes",
  staffPasses: "Technical staff",
  carPasses: "Issuing passes for delivery/removal of equipment and exhibits",
  mountingPasses: "Work passes",

  outOf: "{amount} out of {total}",

  subexpPart1: "Distribute passes",
  subexpPart2: "here",

  packageTitle: "Batch upload",
  packageDescription:
    "To order passes, you can also use batch upload. Fill out the form of the document and download.",

  packageTitle__Participant: "Batch upload of exhibitor passes",
  packageDescription__Participant:
    "To order exhibitor passes, you can also use batch upload. Fill out the form of the document and download.",

  packageTitle__Montage: "Batch upload",
  packageDescription__Montage:
    "To order passes, you can also use batch upload. Fill out the form of the document and download.",

  packageDownloadBlank: "Download form",
  packageUploadFile: "Upload",

  addPass: "Add pass",
  deleteAll: "Delete all",
  reload: "Update",

  deleteAllPopup: "Are you sure? This will delete all of your passes.",
  deletePassPopup:
    "Are you sure you want to delete this pass? A deleted pass will be blocked!",

  deadlineReachedAndNoPasses: `
   The opportunity of passes issue in the Personal Account is closed. <br />
    Unfortunately, you did not follow the deadline for registration of passes. <br />

    <br /><br />

    Kindly thank you for understanding.
  `,

  printNote: `
      The download or print functions are opened 3 days before the Mounting of the exhibition.
  `,

  errors: {
    invalid_or_empty_document: "Application form is blank or incorrect",
    file_upload_error: "There was an error while uploading file to our servers",
    quota_reached: "You have exceeded the allocated quota",
    date_validation_error:
      "Check the correctness of filling the birthday field",
    fields_validation_error:
      "Check the correctness of filling the fields: {fields}",
    validation_errors:
      "Check the correctness of filling the fields in the rows",
    default: "Server error"
  },
  sort: {
    by_date_asc: "by date added (new)",
    by_date_desc: "by date added (old)",
    by_name_asc: "by surname (A-Z)",
    by_name_desc: "by surname (Z-A)"
  },
  qr: {
    uploadQR: "Download QR code",
    downloadedQR: "QR code downloaded",
    noDownloadedQR: "Rejected or not loaded",
    errorNoDownloadedQR: "QR code not downloaded",
    changeBtn: "Change",
    errorSize:
      "File is too large ({filesize}). Maximum file size: {maxFilesize}Mb.",
    errorAccepted:
      "File upload error: allowable file formats are PDF, JPG, JPEG",
    titlePassesNoUpload: "QR code of the vaccinated/cured person",
    titlePassesUpload: "QR code",
    notePasses: "Please note!",
    stepPasses1: "The QR code image must be clear.",
    stepPasses2: "File must be in PDF or JPG format, maximum size 5Mb",
    downloadFile: "Download file",
    linkCertificate: "Link to certificate",
    requiredField: "Required",
    tryAgain: "Try again",
    backBtn: "Back",
    codeSuccessfullyScanned: "Your code was successfully scanned.",
    pointCameraQRCode: "Please point your camera at the QR code.",
    errorQRScannerHTTPS:
      "The camera can only be accessed via the HTTPS transmission protocol.",
    errorQRScannerStreamApi: "Stream API is not supported in this browser.",
    errorQRScannerOverconstrainedError: "The installed camera is not suitable.",
    errorQRScannerNotReadableError: "The camera is already in use.",
    errorQRScannerNotSupportedError: "The connection is not secure.",
    errorQRScannerNotFoundError: "You do not have a camera.",
    errorQRScannerNotAllowedError:
      "You have disabled camera access, enable access in your browser settings.",
    downloadQRCodePDF: "Download a certificate file in PDF format",
    downloadQRCodeImageJPG: "Or download a QR code image in JPG format",
    downloadCertificate: "Download a certificate",
    scanQRCode: "Scan a QR code",
    chooseDownloadQRCOde: "Choose a way to download a QR code",
    scanQRCodeWithCamera: "Scan a QR code image using your device camera."
  },

  participant: {
    warningPass:
      "Do not forget to print or save the participant's certificates you have issued to your phone! Use them to pass through the entrance turnstiles of the EXPOCENTRE Fairgrounds.",
    downloadBlank: "/static/pass-template/participant-template-en.xlsx",
    deadlinesText: "Exhibition period: {from} — {to}.",
    quotaText:
      "You can order additional exhibitor IDs via the Order of services section in your Personal exhibitor account.",

    addTitle: "Add exhibitor pass",
    applicationTitle: "Pass application",

    companyName: "Pass company name",

    birthdayPlaceholder: "DD.MM.YYYY",
    birthplacePlaceholder: "As in passport or ID",

    packageUploadSize: "xlsx, 12 KB",
    warningMessage: "Printing of exhibitor passes is available as of {date}.",
    chooseCitizenship: "Specify your nationality",
    citizenship: "Nationality",
    eVisaInfo:
      "E-Visa gives you the right to enter and stay in the Russian Federation on a private or business visit, tourism, and is valid for 16 days from the date of entry. Applicants for an E-Visa do not need an Invitation letter.",
    visaInfo:
      "Exhibitor Passes with an issued invitation to enter the Russian Federation cannot be printed out from a Personal Account.\n" +
      "After receiving an invitation to enter the Russian Federation and arriving at the exhibition, please proceed to Service Bureau of EXPOCENTRE AO to receive an Exhibitor Pass in person and against signature upon presentation of an identity document.\n",
    visaHelp1: "Any questions?",
    visaHelp2: "Contact a specialist in the Protocol Department: ",
    isVisaInvite: "Issue invitations for entry to the Russian Federation",
    visaSimpleInfo1:
      "In case the Applicant is a citizen of the country in respect of which the Visa Facilitation Agreement is in force, the Invitation shall be issued by EXPOCENTRE AO.",
    visaSimpleInfo2:
      "Processing of this type of Invitation shall be included in the cost of participation in the exhibition.",
    visaSimpleInfo3:
      "Processing of the Invitation may require up to 5 (five) working days after receiving the Request containing all the necessary information.",
    visaNotSimpleInfo1:
      "In case the Applicant is a citizen of the country in respect of which the Visa Facilitation Agreement does not apply, the Invitation shall be issued by the Migration Department of the Main Department of the Russian Ministry of Internal Affairs in Moscow.  ",
    visaNotSimpleInfo2:
      "Processing of this type of the Invitation shall be paid according to the Rates for Services Provided at Exhibitions Held at EXPOCENTRE Fairgrounds valid at the moment of the issuing the invoice.",
    visaNotSimpleInfo3:
      "Processing of the Invitation in the Migration Department of the Main Department of the Russian Ministry of Internal Affairs in Moscow may require up to 25 (twenty-five) working days after the receipt of payment and submission of documents.",
    visaAverageLateNotification:
      "Unfortunately, it's too late to apply for a formal invitation issued by the Administration for Migration Issues of the Ministry of Internal Affairs of Russia in Moscow. Process can take up to 50 days.",
    visaSimpleLateNotificationL:
      "Unfortunately, it's too late to apply for a formal invitation issued by EXPOCENTRE AO. Process can take up to 5 days.",
    visaPassApplied:
      "Contact Service Bureau of EXPOCENTRE AO to obtain an exhibitor badge personally and\n" +
      "against signature. You need to have your ID to register there.\n",
    visaPassAppliedContacts:
      "Phone: +7 499 428-03-00, e-mail: pass@expocentr.ru",
    visaPassRejected:
      "Applicants for an E-Visa do not need an invitation letter.",
    visaPassRejected2:
      "Or it's too late to apply for a formal invitation issued by EXPOCENTRE AO. Process can take up to {amount} days."
  },

  equipmentLetters: {
    addTitle: "Create an equipment and exhibits delivery/removal letter",
    editTitle: "Edit an equipment and exhibits delivery/removal letter",
    customerTitle: "Carrier details",
    carrierCompany: "Company handling delivery and removal",
    carrierCountry: "Country of the delivery and removal company",
    itemsTitle: "Equipment, exhibits and other material assets",
    itemTitle: "Name",
    quantity: "Quantity",
    quantityInvalid: "Enter a number from 1 to 100000",
    deleteItem: "Delete item",
    addItem: "Add item",
    signerTitle: "Signatory",
    signerFullName: "Full name",
    signerPosition: "Position",
    responsibleTitle: "Person responsible for work at the exhibition area",
    responsibleFullName: "Full name",
    responsiblePhone: "Phone",
    addButton: "Add letter",
    stand: "Stand",
    carrier: "Carrier",
    createdAt: "Created",
    fileName: "crocus_Letter_for_delivery_removal_of_equipment_and_exhibits",
    empty: "No letters have been created yet",
    standRequired: "Select a stand",
    itemsRequired: "Add at least one item"
  },

  car: {
    rulesTitle:
      "Rules for entrance and stay of vehicles at Expocentre Fairgrounds",
    warningAutoPass:
      "Do not forget to print or save the one-entry car passes you have issued to your phone! Hand over your one-entry pass to a security guard at the entrance gate for entering to the territory of Expocentre Fairgrounds.",
    addTitle: "Add one-entry car pass",
    carApplicationTitle: "Application form for one-entry car pass",
    driverApplicationTitle: "Driver information",
    cargoApplicationTitle: "Cargo information",

    govVehicleNumber: "Number plate",
    govTrailerNumber: "Trailer number plate",
    arrivalDate: "Entrance date",
    departureDate: "Departure date",
    carryingCapacity: "Carrying capacity",
    carryingCapacitySmall: "carrying capacity",
    vehicleType: "Type plate",
    arrivalPurpose: "Entrance purpose",
    pavilion: "Pavilion",
    hall: "Hall",
    stand: "Stand",
    status: "Status",
    statusAccepted: "Approved",
    statusRejected: "Rejected",
    statusPending: "Under consideration",
    qrCode: "QR code",

    birthYear: "Birth year",
    birthYearPlaceholder: "YYYY",

    birthplacePlaceholder: "As in passport or ID",

    cargoName: "Cargo name",
    cargoNamePlaceholder: "Description",
    cargoQty: "Number",

    addCargo: "Add cargo",

    considerationStatus: "Checking",
    rejectedStatus: "Rejected",
    downloadRules: "Download files",
    entryRules: "The order of import/export of equipment and exhibits",
    locationRules:
      "Rules for the location of vehicles on the territory of the exhibition complex",
    appForms:
      "Application forms (Sample power of attorney, Delivery/Removal Permit, Application for work and service passes etc.) ",
    warningMessage:
      "Printing of one-time vehicle passes is only available after the data entered is checked"
  },

  montage: {
    warningMontagePass:
      "Do not forget to print or save the passes for employees of contractors you have issued to your phone! Use them to pass through the entrance turnstiles of the EXPOCENTRE Fairgrounds.",
    title: "Passes for employees of contractors",
    downloadBlank: "/static/pass-template/montage-template-en.xlsx",
    installationPeriod: "Mounting period: {from} — {to}",
    dismantingPeriod: "Dismantling period: {from} — {to}",

    rulesTitle: "Procedure for delivery / removal of equipment and exhibits",
    quotaText:
      "If you need to order extra passes for employees of contractors, please, address Expoconsta OOO, phone: +7 (499) 795-25-36, e-mail: sales@expoconsta.ru",

    addTitle: "Add pass for the assembly/disassembly",
    applicationTitle: "Pass application",

    birthdayPlaceholder: "DD.MM.YYYY",
    birthplacePlaceholder: "As in passport or ID",

    packageUploadSize: "xlsx, 10 KB",
    warningMessage:
      "Printing of passes for employees of contractors is available as of {date}"
  },

  staff: {
    warningStaffPass:
      "Do not forget to print or save the technical staff passes you have issued to your phone! Use them to pass through the entrance turnstiles of the EXPOCENTRE Fairgrounds.",
    downloadBlank: "/static/pass-template/staff-template-en.xlsx",
    deadlinesText: "Mounting period: {from} — {to}",
    quotaText:
      "You can order additional passes for the technical staff via the Order of services section in your Personal exhibitor account as additional exhibitor IDs.",

    addTitle: "Add technical staff pass",
    applicationTitle: "Pass application",

    companyName: "Pass company name",

    packageUploadSize: "xlsx, 10 KB",
    warningMessage:
      "Printing of technical staff passes is available as of {date}"
  }
};
